// ===================================================================
// PA GRANTS — Documents
// ===================================================================

import { Title, Text, Paper, Stack } from '../../components/gab/GabComponents';

export default function Documents() {
  return (
    <Stack gap="md">
      <Title order={3} c="black">Documents</Title>
      <Paper p="md" radius="md">
        <Text c="dimmed">Document management for PA grant files — coming soon.</Text>
      </Paper>
    </Stack>
  );
}
